import { submission } from "../../graphql"
import { graphqlApolloClient } from "../graphql-apollo-client"

const getTechnicalUpdatesBySubmission = async ({ id }) => {
  const { data } = await graphqlApolloClient.query({
    query: submission.queries.getTechnicalUpdatesBySubmissionQuery,
    fetchPolicy: "network-only",
    variables: {
      id
    }
  })

  return data?.TechnicalUpdatesBySubmission
}

export const TechnicalUpdatesServices = {
  getTechnicalUpdatesBySubmission
}